import { createContext } from "react";

export const EnvWarningContext = createContext<{
    warned: boolean;
}>({ warned: false });
